import type { InParkingCardDetail } from 'src/features/cards/types';
import type { CardTag } from 'src/features/memberships/types';
import type { BadgeOption } from 'src/types';

export enum EventType {
    ENTRY_ATTEMPT = 'entry-attempt',
    ENTRY_SUCCESS = 'entry-success',
    ENTRY_FAILED = 'entry-failed',
    EXIT_ATTEMPT = 'exit-attempt',
    EXIT_SUCCESS = 'exit-success',
    EXIT_FAILED = 'exit-failed',
    SERVICE = 'service',
    EXIT = 'exit',
    ENTRY = 'entry',
}

export interface Event {
    id: number;
    event_type: EventType;
    timestamp: string;
    card_number: string;
    card_type: 'OPERATOR' | 'NORMAL' | 'PREPAID' | 'VIP';
    point_name: string;
    message: string;
    tags: CardTag[];
    photo_path: string;
}

export type SidePanelAttributesType = {
    title: string;
    value: string | number | null | undefined;
    control: InParkingCardDetail | Event | undefined;
    isBadge?: boolean;
    badgeValue?: BadgeOption;
};
